import React from 'react'

import { requestPut, } from '../../../modules/request/index'
import { getSafeRedirect, } from '../../../modules/safeRedirect'
import UnitStage1 from '../components/assignment_flow/create_unit/select_activities_container.jsx'
import EvidenceRestrictedModal from '../components/shared/evidenceRestrictedModal'
import { isEvidenceActivity } from '../components/shared/evidenceGuardedButton'
import { AiRestrictionContext } from '../contexts/AiRestrictionContextProvider'

export default class EditUnitActivitiesContainer extends React.Component {
  constructor(props) {
    super(props)

    // captured at load: the activity filters rewrite the query string, dropping the param
    this.postAssignRedirect = getSafeRedirect('/teachers/classrooms/lesson_planner')

    this.state = { selectedActivities: [], showEvidenceRestrictedModal: false }
  }

  static contextType = AiRestrictionContext

  toggleActivitySelection = (activity) => {
    const activities = this.state.selectedActivities
    const newActivities = activities.find(act => act.id === activity.id) ? activities.filter(act => act.id !== activity.id) : activities.concat([activity])
    this.setState({ selectedActivities: newActivities, })
  };

  getActivityIds = () => {
    const ids = [];
    this.state.selectedActivities.forEach((act)=>ids.push({id: act.id, due_date: null}));
    return ids
  };

  handleCloseEvidenceRestrictedModal = () => {
    this.setState({ showEvidenceRestrictedModal: false, })
  };

  updateActivities = () => {
    const that = this;

    if (this.context && this.state.selectedActivities.some(isEvidenceActivity)) {
      this.setState({ showEvidenceRestrictedModal: true, })
      return
    }

    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/teachers/units/${that.props.match.params.unitId}/update_activities`,
      {
        data: { activities_data: that.getActivityIds(), }
      },
      (body) => {
        window.location = that.postAssignRedirect
      },
      (body) => {
        this.setState({ errors: body.errors, loading: false, })
      }
    )
  };

  render() {
    return (
      <div className="white-background-accommodate-footer">
        {this.state.showEvidenceRestrictedModal && (
          <EvidenceRestrictedModal
            aiRestrictedGroup={this.context}
            onClose={this.handleCloseEvidenceRestrictedModal}
          />
        )}
        <UnitStage1
          editing={Boolean(true)}
          errorMessage={this.state.errors}
          hideNameTheUnit={Boolean(true)}
          selectedActivities={this.state.selectedActivities}
          toggleActivitySelection={this.toggleActivitySelection}
          unitName={this.props.match.params.unitName}
          updateActivities={this.updateActivities}
        />
      </div>
    )
  }
}
